export default function WhatsAppCTA() {
  return (
    <section className="py-20 md:py-28 bg-[#111111] relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20background%20with%20orange%20glowing%20particles%20and%20bokeh%20lights%2C%20modern%20tech%20atmosphere%2C%20phone%20and%20mobile%20accessories%20theme%2C%20dramatic%20lighting%20with%20orange%20glow%20effects%20on%20black%20background&width=1920&height=800&seq=cta001&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#111111]/80 via-[#111111]/60 to-[#111111]/80" />
      </div>

      {/* Glow effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-[#FF4500]/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <div className="w-16 h-16 flex items-center justify-center bg-[#25D366] rounded-2xl mx-auto mb-8 shadow-2xl shadow-[#25D366]/30">
          <i className="ri-whatsapp-line text-white text-3xl" />
        </div>

        <p className="text-white/40 text-xs font-bold uppercase tracking-[0.3em] mb-4">1 Mesaj Uzağında</p>

        <h2
          className="text-white uppercase leading-none mb-5"
          style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(2.5rem, 8vw, 5.5rem)' }}
        >
          Hemen Yaz,
          <br />
          <span className="text-[#FF4500]">Kılıfın Hazır Olsun!</span>
        </h2>

        <p className="text-white/60 text-base md:text-lg mb-10 max-w-xl mx-auto leading-relaxed">
          Sipariş ver, tasarla, bilgi al — hepsi 1 mesaj uzağında.
          Cevap süresi ortalama 2 dakika!
        </p>

        <a
          href="https://wa.me/903222286464?text=Merhaba!%20Kılıf%20hakkında%20bilgi%20almak%20istiyorum."
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5d] text-white px-10 py-5 rounded-full text-base md:text-lg font-black transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-2xl shadow-[#25D366]/30"
        >
          <i className="ri-whatsapp-fill text-xl w-6 h-6 flex items-center justify-center" />
          WhatsApp'tan Yaz
        </a>

        <p className="text-white/25 text-xs mt-6 uppercase tracking-widest">
          Ücretsiz • Hızlı • Kolay
        </p>
      </div>
    </section>
  );
}
